var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessFuture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 265,
    viewBox: "0 0 514 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.145996 190.851C0.145996 190.851 69.987 192.137 101.51 190.851C133.033 189.565 145.541 122.628 185.16 122.628C224.778 122.628 230.17 196.366 272.746 196.366C315.321 196.366 324.385 119.434 360.332 119.434C396.279 119.434 409.154 169.681 438.077 169.681C467 169.681 513 110.388 513 110.388",
    stroke: "#E1E3E8",
    strokeWidth: 3.93646
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.145996 161.669C0.145996 161.669 69.987 109.153 101.51 107.866C133.033 106.58 145.541 154.12 185.16 154.12C224.778 154.12 230.17 77.3589 272.746 77.3589C315.321 77.3589 315.993 13.2212 357.845 13.2212C399.697 13.2212 422.331 92.1206 438.077 93.1047C453.823 94.0888 512.87 93.1047 512.87 93.1047V264.341H0.145996L0.145996 161.669Z",
    fill: "url(#paint0_linear_649_976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.145996 161.669C0.145996 161.669 69.987 109.153 101.51 107.866C133.033 106.58 145.541 154.12 185.16 154.12C224.778 154.12 230.17 77.3589 272.746 77.3589C315.321 77.3589 318.48 13.2212 360.332 13.2212C402.184 13.2212 401.154 93.1047 438.077 93.1047C475 93.1047 513 -3.61182 513 -3.61182",
    stroke: "#55BDB3",
    strokeWidth: 3.93646
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.332 264.34V30.1211",
    stroke: "#D292FF",
    strokeWidth: 1.96823
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.332,
    cy: 12.407,
    r: 9.84114,
    fill: "white",
    stroke: "#D292FF",
    strokeWidth: 3.93646
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_976",
    x1: 98.3403,
    y1: 101.961,
    x2: 96.881,
    y2: 262.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AE1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04BFDA",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 264.14,
    fill: "white",
    transform: "translate(0.5 0.517578)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessFuture);
export default __webpack_public_path__ + "static/media/businessFuture.9adfb375c0c25e4379a3a5bc29a53acc.svg";
export { ForwardRef as ReactComponent };